var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket"},[_c('NavBar',{attrs:{"titleTranslationPath":"ticketPayment.title"}}),_c('div',{staticClass:"content"},[_c('Loader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }